import React from 'react';

export const PageLoader: React.FC = () => {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '60vh',
        width: '100%',
      }}
      aria-label="Loading content"
      role="status"
    >
      <div
        style={{
          width: '42px',
          height: '42px',
          border: '3px solid rgba(31, 100, 164, 0.15)',
          borderTop: '3px solid #1f64a4',
          borderRadius: '50%',
          animation: 'essSpin 0.75s linear infinite',
        }}
      />
      <style>{`
        @keyframes essSpin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default PageLoader;
